<template>
  <div class="create-tracking-category-popup-flow">
    <create-tracking-category-popup v-if="currentComponent === componentNames.createTrackingCategoryPopup"
                                    @done-clicked="showNext()" @close="close()"/>
    <create-tracking-category-amount-popup v-else-if="currentComponent === componentNames.createTrackingCategoryAmountPopup"
                                           v-on:close="close()" @back-clicked="showPrevious()"/>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import CreateTrackingCategoryPopup from './CreateTrackingCategoryPopup.vue';
import CreateTrackingCategoryAmountPopup from './CreateTrackingCategoryAmountPopup.vue';

const componentNames = {
  createTrackingCategoryPopup: 'create-tracking-category-popup',
  createTrackingCategoryAmountPopup: 'create-tracking-category-amount-popup',
};

export default {
  name: 'CreateTrackingCategoryPopupFlow',
  components: {
    CreateTrackingCategoryPopup,
    CreateTrackingCategoryAmountPopup,
  },
  data() {
    return {
      currentComponent: componentNames.createTrackingCategoryPopup,
    };
  },
  created() {
    this.initialize();
  },
  computed: {
    componentNames() {
      return componentNames;
    },
  },
  methods: {
    ...mapActions('createTrackingCategory', ['initialize']),
    showNext() {
      if (this.currentComponent === this.componentNames.createTrackingCategoryPopup) {
        this.currentComponent = componentNames.createTrackingCategoryAmountPopup;
      }
    },
    showPrevious() {
      if (this.currentComponent === this.componentNames.createTrackingCategoryAmountPopup) {
        this.currentComponent = componentNames.createTrackingCategoryPopup;
      }
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
  .create-tracking-category-popup-flow {}
</style>
